export default "__VITE_ASSET__DztvG$_7__"